module.exports = __webpack_public_path__ + "img/banner2.1157f096.png";